import Metrics from '@/api/metrics'
import Utils from '@/utils/charts'

export default {
  fetch: ({ commit }, { id, params = {} }) => {
    const key = Utils.datasetIdentifier(id, params)
    commit('updateDataset', { id: key, data: { loading: true } })
    return Metrics[id]({ params })
      .then(({ data }) => commit('updateDataset', { id: key, data }))
      .catch(error => {
        commit('updateDataset', { id: key, data: { loading: false } })
        throw error
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/metrics/actions.js